import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@prezzee/ribbon-ui/lib/components/Modal';
import Typography from '@prezzee/ribbon-ui/lib/components/Typography';
import { SystemProps } from '@chakra-ui/system';
import Button from '@prezzee/ribbon-ui/lib/components/Button';
import Box from '@prezzee/ribbon-ui/lib/components/Box';
import { VStack } from '@prezzee/ribbon-ui/lib/components/Stack';
import useDisclosure from '@prezzee/ribbon-ui/lib/hooks/useDisclosure';
import ChevronLeftIcon from '@prezzee/ribbon-ui/lib/components/icons/ChevronLeftIcon';
import { Fragment } from 'react';
import RetailerListModal from '../RetailerListModal';
import { useProduct } from 'contexts/ProductPageContext';
import { COUNTRY, envUtil } from 'common/util';

interface SwappableCardModalProps {
  onClose: () => void;
}

const SwappableCardModal = ({ onClose }: SwappableCardModalProps) => {
  const retailerListDialog = useDisclosure();
  const {
    sku: { uid },
  } = useProduct();

  return (
    <Fragment>
      <Modal isOpen onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pb={0}>
            <Typography variant="h2" color="gray.800" fontSize="24" fontWeight="bold">
              Prezzee Plus eGift Card
            </Typography>
          </ModalHeader>
          <ModalCloseButton mt={3} />
          <ModalBody>
            <Typography variant="body" color="gray.600" fontSize="16" lineHeight="24px" fontWeight="normal" mb={4}>
              This unique Prezzee-issued card gives recipients the freedom to choose where to spend it; at the brand you
              selected for them, or at another available brand of their choice.
            </Typography>

            <Typography variant="body" color="gray.600" fontSize="16" lineHeight="24px" fontWeight="normal" mb={4}>
              Buying a Prezzee Plus eGift Card is a great way to ensure your giftee gets the most out of their gift and
              treat themselves to something they truly love, need or want!
            </Typography>

            <Typography variant="body" color="gray.600" fontSize="16" lineHeight="24px" fontWeight="normal" mb={4}>
              {envUtil.getCountry() === COUNTRY.UnitedStates ? (
                <>
                  Prezzee Plus eGift Cards have no expiry date. Once a brand is selected, a new card will be issued and
                  Terms and Conditions will be according to the chosen brand.
                </>
              ) : (
                <>
                  Prezzee Plus eGift Cards are valid for 3 years from the date of issue. Once a brand is selected, a new
                  eGift Card will be issued and the expiry date and the Terms and Conditions will be according to the
                  chosen brand.
                </>
              )}
            </Typography>

            <VStack {...buttonStackStyles}>
              <Button
                color="blue.500"
                fontSize="16px"
                fontWeight="normal"
                onClick={retailerListDialog.onOpen}
                textDecoration="underline"
                variant="link"
                mb={4}
              >
                See available brands
              </Button>
              <Button variant="primary" onClick={onClose} width="full">
                Got it
              </Button>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
      <RetailerListModal
        showDefaultStore
        isOpen={retailerListDialog.isOpen}
        onClose={() => {
          retailerListDialog.onClose();
          onClose();
        }}
        uid={uid}
        title={
          <>
            <Button
              leftIcon={
                <Box>
                  <ChevronLeftIcon />
                </Box>
              }
              variant="unstyled"
              onClick={retailerListDialog.onClose}
            >
              Back
            </Button>
            <br />
            Available brands
          </>
        }
      />
    </Fragment>
  );
};

const buttonStackStyles: SystemProps = {
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  mb: 4,
};

export default SwappableCardModal;
